import { useState } from 'react';

const services = [
  {
    icon: 'ri-search-eye-line',
    title: 'Due Diligence',
    description:
      'Análise aprofundada e rigorosa de empresas, activos e oportunidades de investimento. Identificamos riscos e oportunidades antes de qualquer decisão estratégica.',
    tags: ['Financeira', 'Legal', 'Operacional'],
  },
  {
    icon: 'ri-merge-cells-horizontal',
    title: 'Fusões & Aquisições',
    description:
      'Assessoria completa em processos de M&A — desde a identificação de alvos até ao fecho da transacção, garantindo o máximo valor para o seu negócio.',
    tags: ['M&A', 'Valuation', 'Negociação'],
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Estratégia Empresarial',
    description:
      'Desenvolvemos planos estratégicos robustos e personalizados, alinhados com os objectivos de crescimento e sustentabilidade da sua organização.',
    tags: ['Planeamento', 'Crescimento', 'Inovação'],
  },
  {
    icon: 'ri-building-2-line',
    title: 'Reestruturação Organizacional',
    description:
      'Optimizamos estruturas organizacionais para aumentar a eficiência, reduzir custos e preparar a empresa para os desafios do mercado angolano.',
    tags: ['Eficiência', 'Processos', 'Cultura'],
  },
  {
    icon: 'ri-funds-line',
    title: 'Captação de Investimento',
    description:
      'Apoiamos empresas na preparação e execução de processos de captação de capital, conectando-as com investidores estratégicos nacionais e internacionais.',
    tags: ['Capital', 'Investidores', 'Pitch'],
  },
  {
    icon: 'ri-global-line',
    title: 'Expansão de Mercado',
    description:
      'Guiamos empresas na entrada e expansão em novos mercados africanos, com análise de viabilidade, regulamentação local e estratégias de penetração.',
    tags: ['África', 'Mercados', 'Regulação'],
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Consultoria Estratégica e Organizacional',
    description:
      'Apoiamos organizações na definição de rumo estratégico e na transformação das suas estruturas internas para responder com agilidade às exigências do mercado.',
    tags: ['Estratégia', 'Organização', 'Transformação'],
  },
  {
    icon: 'ri-graduation-cap-line',
    title: 'Formação e Capacitação Profissional',
    description:
      'Desenvolvemos programas de formação customizados para equipas e líderes, reforçando competências técnicas e comportamentais alinhadas com os objectivos da organização.',
    tags: ['Formação', 'Liderança', 'Competências'],
  },
  {
    icon: 'ri-briefcase-4-line',
    title: 'Gestão e Desenvolvimento de Negócios',
    description:
      'Identificamos e desenvolvemos oportunidades de negócio, optimizando processos de gestão para maximizar a performance e o crescimento sustentável da sua empresa.',
    tags: ['Gestão', 'Crescimento', 'Performance'],
  },
  {
    icon: 'ri-megaphone-line',
    title: 'Marketing, Comunicação e Branding',
    description:
      'Desenvolvemos estratégias de marketing e comunicação integradas que fortalecem a identidade da marca, aumentam a visibilidade e criam ligações duradouras com o público-alvo.',
    tags: ['Marketing', 'Branding', 'Comunicação'],
  },
];

export default function ServicesSection() {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <section id="servicos" className="bg-[#F5F2EE] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 border border-[#026A86]/40 rounded-full px-4 py-1.5 mb-6">
            <span className="text-[#026A86] text-xs font-medium tracking-widest uppercase">
              O Que Fazemos
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#011820] mb-4 leading-tight">
            Soluções completas para
            <br />
            <span className="text-[#026A86]">o seu negócio</span>
          </h2>
          <p className="text-[#011820]/50 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Combinamos experiência local com metodologias internacionais para entregar
            resultados concretos e duradouros.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service, idx) => (
            <div
              key={service.title}
              onMouseEnter={() => setHovered(idx)}
              onMouseLeave={() => setHovered(null)}
              className={`group relative rounded-xl p-5 border transition-all duration-400 cursor-default ${
                hovered === idx
                  ? 'bg-[#026A86] border-[#026A86]'
                  : 'bg-white border-[#e8e3dc] hover:border-[#026A86]/40'
              }`}
            >
              {/* Icon */}
              <div
                className={`w-9 h-9 flex items-center justify-center rounded-lg mb-3 transition-all duration-300 ${
                  hovered === idx ? 'bg-white/20' : 'bg-[#026A86]/10'
                }`}
              >
                <i
                  className={`${service.icon} text-base ${
                    hovered === idx ? 'text-white' : 'text-[#026A86]'
                  }`}
                />
              </div>

              {/* Title */}
              <h3
                className={`text-sm font-bold mb-2 transition-colors duration-300 ${
                  hovered === idx ? 'text-white' : 'text-[#011820]'
                }`}
              >
                {service.title}
              </h3>

              {/* Description */}
              <p
                className={`text-xs leading-relaxed mb-3 transition-colors duration-300 ${
                  hovered === idx ? 'text-white/80' : 'text-[#011820]/55'
                }`}
              >
                {service.description}
              </p>

              {/* Tags */}
              <div className="flex flex-wrap gap-1.5">
                {service.tags.map((tag) => (
                  <span
                    key={tag}
                    className={`text-[10px] px-2 py-0.5 rounded-full font-medium transition-all duration-300 ${
                      hovered === idx
                        ? 'bg-white/20 text-white'
                        : 'bg-[#026A86]/10 text-[#026A86]'
                    }`}
                  >
                    {tag}
                  </span>
                ))}
              </div>

              {/* Arrow */}
              <div
                className={`absolute top-5 right-5 w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 ${
                  hovered === idx ? 'bg-white/20 opacity-100' : 'opacity-0'
                }`}
              >
                <i className="ri-arrow-right-up-line text-white text-xs" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
